import { Component } from '@angular/core';
import { NotificationAdapterService } from '../../services/messaging/notification-adapter.service';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem } from '@angular/material/list';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatBadge } from '@angular/material/badge';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-user-notification',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatList,
    MatListItem,
    MatIconButton,
    MatBadge,
    MatButton,
    MatTooltip,
  ],
  templateUrl: './user-notification.component.html',
  styleUrl: './user-notification.component.scss',
})
export class UserNotificationComponent {
  notifications$ = this.notificationAdapter.notifications$;
  countUnReadNotifications$ =
    this.notificationAdapter.totalUnReadNotifications$;

  constructor(private notificationAdapter: NotificationAdapterService) {}

  markAsRead(notificationId?: string) {
    if (notificationId) {
      this.notificationAdapter.markNotificationAsRead(notificationId);
    }
  }

  markAllAsRead() {
    this.notifications$().forEach((n) =>
      this.notificationAdapter.markNotificationAsRead(n.notificationId ?? '')
    );
  }

  clearNotifications() {
    this.notificationAdapter
      .deactivateAllNotifications()
      .then((r) => console.log(r));
  }
}
